// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '../store/index'
import router from '../router/index'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import VeeValidate from 'vee-validate'
import '../metrics'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vDialog from 'v-dialogs'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
// import VuePlyr from 'vue-plyr'
import VueApexCharts from 'vue-apexcharts'
import VueSelectImage from 'vue-select-image'
import { VueEditor } from 'vue2-editor'

import moment from 'moment'
import VueExcelXlsx from 'vue-excel-xlsx'
Vue.use(moment)
Vue.component('VueEditor', VueEditor)
Vue.use(VueSelectImage)

Vue.use(VueExcelXlsx)

// add stylesheet
require('vue-select-image/dist/vue-select-image.css')

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// The second argument is optional and sets the default config values for every player.
// Vue.use(VuePlyr, {
//   plyr: {
//     fullscreen: { enabled: false },
//   },
//   emit: ['ended'],
// })
Vue.use(Viewer)
Vue.component('VueElementLoading', VueElementLoading)
window.axios = axios
Vue.use(axios)

// Production

axios.defaults.baseURL = "https://cyberhawk-api.leopardtechlabs.in"
Vue.prototype.baseURL="https://cyberhawk-api.leopardtechlabs.in/document/get/"
Vue.prototype.mediaURL="https://cyberhawk-api.leopardtechlabs.in/file/get/"
Vue.prototype.ipURL = "https://cyberhawk-api.leopardtechlabs.in"

// axios.defaults.baseURL = 'http://3.109.132.76'
// Vue.prototype.baseURL="http://3.109.132.76/document/get/"
// Vue.prototype.mediaURL="http://3.109.132.76/file/get/"

// Test
// axios.defaults.baseURL = "https://l6v8f8f0-4003.inc1.devtunnels.ms/"
// Vue.prototype.baseURL="https://l6v8f8f0-4003.inc1.devtunnels.ms/document/get/"
// Vue.prototype.mediaURL="https://l6v8f8f0-4003.inc1.devtunnels.ms/file/get/"
// Vue.prototype.ipURL = "https://l6v8f8f0-4003.inc1.devtunnels.ms/"

// axios.defaults.baseURL = 'http://localhost:4003'
// Vue.prototype.baseURL = 'http://localhost:4003/document/get/'
// Vue.prototype.mediaURL = 'http://localhost:4003/file/get/'
// Vue.prototype.ipURL = 'http://localhost:4003'

Vue.use(Vuex)
Vue.use(BootstrapVue, {
  BModal: {
    okTitle: 'OK',
    cancelTitle: 'Cancel',
  },
})
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

Vue.use(vDialog, {
  language: 'en',
  i18n: 'en',
  alert: {
    title: 'Alert',
    ok: 'OK',
    okText: 'OK',
    okTitle: 'OK',
  },
  confirm: {
    title: 'Confirm',
    ok: 'OK',
    okText: 'OK',
    okTitle: 'OK',
    cancel: 'Cancel',
    cancelText: 'Cancel',
    cancelTitle: 'Cancel',
  },
})

// Global override to fix Chinese text in v-dialogs
const originalAlert = Vue.prototype.$dlg.alert
Vue.prototype.$dlg.alert = function (message, callback, options) {
  const mergedOptions = {
    title: 'Alert',
    ok: 'OK',
    okText: 'OK',
    okTitle: 'OK',
    ok_title: 'OK',
    language: 'en',
    i18n: 'en',
    ...options,
  }
  return originalAlert.call(this, message, callback, mergedOptions)
}

const originalConfirm = Vue.prototype.$dlg.confirm
Vue.prototype.$dlg.confirm = function (message, callback, options) {
  const mergedOptions = {
    title: 'Confirm',
    ok: 'OK',
    okText: 'OK',
    okTitle: 'OK',
    ok_title: 'OK',
    cancel: 'Cancel',
    cancelText: 'Cancel',
    cancelTitle: 'Cancel',
    cancel_title: 'Cancel',
    language: 'en',
    i18n: 'en',
    ...options,
  }
  return originalConfirm.call(this, message, callback, mergedOptions)
}

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)

Vue.use(ColorThemePlugin,
  {
    // Add or change theme colors here
    themes: {
      // primary: '#f06595',
      // blurple: '#7289DA',
    },
  })

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
